import { ofType, combineEpics } from 'redux-observable';
import { flatMap, tap, ignoreElements } from 'rxjs/operators';
import * as Sentry from '@sentry/browser'
import * as Actions from 'modules/filter_builder/actions'

const addSentryBreadcrumb = val => (
  Sentry.addBreadcrumb({
    category: 'redux.action',
    data: val,
    level: 'debug'
  })
)

const addNewFilter = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.ADD_NEW_FILTER),
  tap(addSentryBreadcrumb),
  flatMap(() => [
    Actions.changeView('Selection')
  ])
)

const addNewGroup = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.ADD_NEW_GROUP),
  tap(addSentryBreadcrumb),
  flatMap(() => [
    Actions.changeView('Selection')
  ])
)

const editFilterProperty = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.EDIT_FILTER_PROPERTY),
  tap(addSentryBreadcrumb),
  flatMap(() => [
    Actions.changeView('Properties')
  ])
)

const editFilterValue = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.EDIT_FILTER_VALUE),
  tap(addSentryBreadcrumb),
  flatMap(() => [
    Actions.changeView('Operator')
  ])
)

const applyFilter = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.APPLY_FILTER),
  tap(addSentryBreadcrumb),
  flatMap(() => [
    Actions.changeView('Filter'),
    Actions.resetFilterAndGroupIndex()
  ]),
)

const changeView = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.CHANGE_VIEW),
  tap(addSentryBreadcrumb),
  ignoreElements()
)

const changeSegment = (action$) => action$.pipe(
  ofType(Actions.ActionTypes.CHANGE_SEGMENT),
  tap(addSentryBreadcrumb),
  ignoreElements()
)

export default combineEpics(
  addNewFilter,
  addNewGroup,
  editFilterProperty,
  editFilterValue,
  applyFilter,
  changeView,
  changeSegment,
)